import { useEffect, useState } from "react";
import IconButton from "@mui/material/IconButton";
import Collapse from "@mui/material/Collapse";
import CloseIcon from "@mui/icons-material/Close";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Alert from "@mui/material/Alert";
import Divider from "@mui/material/Divider";
import Skeleton from "@mui/material/Skeleton";
import Stack from "@mui/material/Stack";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { LoadingSvg } from "../../../../utils/SvgIcons";
import TicketsListsQuery from "./TicketsListsQuery";
import TicketsLists from "./TicketsLists";
import { getAllTitleTicketsApi } from "../../../../../../services/supportApi";
import {
  customToastify,
  checkErrorMessage,
  checkResponseData,
} from "../../../../utils/utilsFunctions";

export default function ManageTickets() {
  const [fetchedTicketsList, setFetchedTicketsList] = useState({
    docs: [],
    loading: "llmmt-loading",
  });
  const [queryTicketsListData, setQueryTicketsListData] = useState({});
  const [pageAndPerPage, setPageAndPerPage] = useState({
    page: 1,
    perPage: 10,
    totalPages: 0,
    hasNextPage: false,
    hasPrevPage: false,
    totalDocs: 0,
  });
  const [controlAlert, setControlAlert] = useState({
    open: true,
    message: "لطفا یکی از گزینه های بالا را انتخاب کنید و روی مشاهده کلیک کنید",
    severity: "warning",
    SkeletonDisplay: "none",
  });

  // کنترل شماره صفحه و تعداد در هر صفحه
  const setNumberPageAndPerPage = (type, number) => {
    let newValues = {};
    if (type == "page") newValues["page"] = number;
    if (type == "perPage") {
      newValues["perPage"] = number;
      newValues["page"] = 1;
    }
    const PageAndPerPageValue = { ...pageAndPerPage, ...newValues };
    setPageAndPerPage(PageAndPerPageValue);
    getTicketsListFromBack(
      "getListTickets",
      queryTicketsListData,
      PageAndPerPageValue
    );
  };

  const getTicketsListFromBack = async (request, data, paginateData = {}) => {
    try {
      setControlAlert({
        open: true,
        message: "درخواست ارسال شد",
        severity: "warning",
        SkeletonDisplay: "Block",
      });
      setFetchedTicketsList({ docs: [], loading: "llmmt-loading" });
      let paginate = { ...pageAndPerPage, ...paginateData };
      if (request == "getListTickets") {
        let response = await getAllTitleTicketsApi(data, paginate);
        const resData = checkResponseData(response);
        if (resData["success"]) {
          setFetchedTicketsList(resData["data"]);
          setControlAlert({
            open: true,
            message: "جواب آمد",
            severity: "warning",
            SkeletonDisplay: "none",
          });
          const { totalPages, hasNextPage, hasPrevPage, page, totalDocs } =
            resData["data"];
          const newValues = {
            totalPages,
            hasNextPage,
            hasPrevPage,
            page,
            totalDocs,
          };
          setPageAndPerPage({
            ...pageAndPerPage,
            ...paginateData,
            ...newValues,
          });
        } else {
          setControlAlert({
            open: true,
            message: "مشکلی پیش آمده است",
            severity: "warning",
            SkeletonDisplay: "none",
          });
        }
      }
    } catch (error) {
      setFetchedTicketsList({ docs: [], loading: "llmmt-Error-loading" });
      const errData = checkErrorMessage(error);
      customToastify("error", errData["titles"] || errData["message"]);
      console.error(error);
    }
  };

  useEffect(() => {
    getTicketsListFromBack("getListTickets", {});
  }, []);

  return (
    <>
      {fetchedTicketsList.loading &&
        fetchedTicketsList.loading == "llmmt-loading" ? (
        <Box
          sx={{
            backgroundColor: "#001e6a",
            m: 1,
            px: 1,
            py: 5,
            color: "white",
            borderRadius: 5,
            textAlign: "center",
          }}
        >
          <LoadingSvg />
          <Divider>لطفا تا بارگزاری اطلاعات صبر کنید </Divider>
        </Box>
      ) : fetchedTicketsList.loading &&
        fetchedTicketsList.loading == "llmmt-Error-loading" ? (
        <Typography>خطا در بارگزاری اطلاعات لطفا دوباره تلاش کنید</Typography>
      ) : (
        <>
          <Accordion sx={{ mt: 1 }} defaultExpanded={true}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography>فیلتر اطلاعات</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <TicketsListsQuery
                setQueryTicketsListData={setQueryTicketsListData}
                getTicketsListFromBack={getTicketsListFromBack}
              />
            </AccordionDetails>
          </Accordion>
          <Divider />
          <Collapse in={controlAlert.open}>
            <Alert
              severity={controlAlert.severity}
              action={
                <IconButton
                  aria-label="close"
                  color="inherit"
                  size="small"
                  onClick={() => {
                    setControlAlert({
                      open: false,
                      message: "",
                      severity: "info",
                      SkeletonDisplay: "none",
                    });
                  }}
                >
                  <CloseIcon fontSize="inherit" />
                </IconButton>
              }
              sx={{ mb: 2 }}
            >
              {controlAlert.message}
            </Alert>
          </Collapse>
          <Stack sx={{ display: controlAlert.SkeletonDisplay }} spacing={1}>
            <Skeleton />
            <Skeleton animation="wave" />
            <Skeleton animation="wave" />
          </Stack>
          <TicketsLists
            fetchedTicketsList={fetchedTicketsList}
            pageAndPerPage={pageAndPerPage}
            setNumberPageAndPerPage={setNumberPageAndPerPage}
          // editStudentOfAcademy={editStudentOfAcademy}
          />
          {/* <ToastContainer
            position="bottom-center"
            autoClose={2500}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={true}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
          /> */}
        </>
      )}
    </>
  );
}

// fetchedTicketsList
let fetchedStudentsListSample =
// {
//   data: {
//     success: true,
//     message: " درخواست با موفقیت انجام شد",
// data:
{
  docs: [
    {
      _id: "6353a187d32c549fab96d6f2",
      name: "sdddddddddd",
      userId: "62f20dc7bdff7a043039d469",
      languages: ["en", "fa", "de"],
      mobileNumber: "000000000",
      situation: "ppppppppppp",
      dateValidation: "2022-08-20T16:13:26.175Z",
    },
    {
      _id: "6353a187d32c549fab96d6f2",
      name: "345345345345",
      userId: "62f20dc7bdff7a043039d469",
      languages: ["en", "fa", "de"],
      mobileNumber: "11111111111",
      situation: "kkkkkkkkk",
      dateValidation: "2099-12-31T20:30:00.000Z",
    },
    {
      _id: "6353a187d32c549fab96d6f2",
      name: "frgfgdfgdfg",
      userId: "62f20dc7bdff7a043039d469",
      languages: ["en", "fa", "de"],
      mobileNumber: "22222222222",
      situation: "hhhhhhhhhhhh",
      dateValidation: "2099-12-31T20:30:00.000Z",
    },
  ],
  totalDocs: 50,
  limit: 1,
  totalPages: 25,
  page: 8,
  pagingCounter: 1,
  hasPrevPage: false,
  hasNextPage: true,
  prevPage: null,
  nextPage: 2,
};
//   },
// };
